import { AccountCreate } from "./AccountCreate";
import { AccountEdit } from "./AccountEdit";
import { AccountList } from "./AccountList";
import { AccountShow } from "./AccountShow";

export default {
  list: AccountList,
  create: AccountCreate,
  edit: AccountEdit,
  show: AccountShow,
  recordRepresentation: "name",
};
